
<v-card flat class="mail-entry v-flex" @click="onClick" :ripple = "false">
    <div>
        <p-inc-outbox-avatar
            :sender = "mail.from"
            :dense  = "true"
        />
    </div>
    <div style="width: calc(100% - 64px)">
        <div class="mail-title v-flex">
            <div class="mail-to">
                {{ mail.to }}
            </div>
            <v-spacer />
            <div class="mail-sended">
                {{ sended }}
            </div>
        </div>
        <div class="mail-subject" >
            {{ mail.subject }}
        </div>
        <div class="ml-2 pr-3 mail-footer v-flex" >
            <div class="">
                {{ mail.stepName }}
            </div>
            <v-spacer />
            <div class="primary--text">
                {{ mail.customerName }}
            </div>
        </div>
    </div>
</v-card>
